// extracted by mini-css-extract-plugin
export default {"container":"SettingsAvatar_container__nlmwY","image":"SettingsAvatar_image__7Ete4","overlay":"SettingsAvatar_overlay__+fXWX"};